import { Form, Radio, Space } from "antd";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Styles } from "./styled";
import {
  getOptionsFormAppPart,
  getRuleValidation,
} from "@lhd/components/CloneApp/fieldUtils";
interface IProps {
  isDisabled?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  namePath?: string | string[];
  styleColor?: React.CSSProperties;
  appType?: string;
}

const RadioButton = (props: IProps) => {
  const { item, namePath, style, styleColor = {}, isDisabled, appType } = props;
  const options = getOptionsFormAppPart(item, appType);
  return (
    <Styles
      style={style}
      id={item.id}
      key={item.id}
      className="radio-button"
      color={styleColor?.color}
      background={styleColor?.background}
    >
      <Form.Item
        style={styleColor}
        name={namePath}
        rules={getRuleValidation(item)}
      >
        <Radio.Group style={styleColor} disabled={isDisabled}>
          <Space
            direction={(item.item_config_data?.layout as any) || "horizontal"}
          >
            {options.map((option, i) => {
              return (
                <Radio key={option?.label} value={option?.value?.toString()}>
                  {option?.label}
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </Form.Item>
    </Styles>
  );
};
export default RadioButton;
